import { render, staticRenderFns } from "./TermReport.vue?vue&type=template&id=4f415985"
import script from "./TermReport.vue?vue&type=script&lang=js"
export * from "./TermReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports